<template>
  <PasswordTemplate v-if="currentPage == 'password'"
  :trigger = "triggerPasswordForgot"
  />
  <OtpTemplate v-else-if="currentPage == 'verification'"
  :trigger = "triggerPasswordForgot"
  :email = "email"
  :password="password"
  />
  <div
    class="login-container"
    style="
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: stretch;
      padding: 0.5em 2em;
      height: 100%;
    "
    :style="form_bg ? { 
        backgroundImage: `url(${form_bg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
     } : {}"
    v-else
  >
    <FormHeader title="text.login_title" secondaryTitle="text.login_subtitle" />
    <div
      class="form"
      style="
        background-color: #ecf4f6a8;
        padding: 5%;
        display: flex;
        flex-direction: column;
        align-items: stretch;
        gap: 10px;
        margin: 2%;
        border-radius: 0.5em;
      "
    >
      <input
        v-model="email"
        type="email"
        placeholder="Adresse e-mail"
        :style="validationErrors.email ? errorStyles : defaultStyles"
        @blur="validateField('email', emailPattern)"
      />
      <div class="password-container" style="position: relative">
        <input
          v-model="password"
          :type="showPassword ? 'text' : 'password'"
          placeholder="Mot de passe"
          :style="validationErrors.password ? errorStyles : defaultStyles"
          @blur="validateField('password', passwordPattern)"
        />
        <button
          type="button"
          style="
            position: absolute;
            right: 1.5em;
            top: 50%;
            transform: translateY(-50%);
            background: none;
            border: none;
            cursor: pointer;
          "
          @click="togglePasswordVisibility"
        >
          <svg
            v-if="showPassword"
            xmlns="http://www.w3.org/2000/svg"
            height="16"
            width="20"
            viewBox="0 0 640 512"
          >
            <path
              d="M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zM223.1 149.5C248.6 126.2 282.7 112 320 112c79.5 0 144 64.5 144 144c0 24.9-6.3 48.3-17.4 68.7L408 294.5c8.4-19.3 10.6-41.4 4.8-63.3c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3c0 10.2-2.4 19.8-6.6 28.3l-90.3-70.8zM373 389.9c-16.4 6.5-34.3 10.1-53 10.1c-79.5 0-144-64.5-144-144c0-6.9 .5-13.6 1.4-20.2L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5L373 389.9z"
            />
          </svg>
          <svg
            v-else
            xmlns="http://www.w3.org/2000/svg"
            height="16"
            width="18"
            viewBox="0 0 576 512"
          >
            <path
              d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z"
            />
          </svg>
        </button>
      </div>
      <p
        v-if="validationErrors.password"
        class="password-hint"
        style="font-size: 0.6em"
      >
        <i>
          Password must contain at least 8 characters, including at least 1
          number
        </i>
      </p>

      <div class="forgot-password" style="margin: 1em auto">
        <button
          style="
            text-decoration: underline;
            font-size: small;
            color: #010fa8c7;
            background-color: transparent;
            border: none;
            cursor: pointer;
          "
          @click="triggerPasswordForgot"
        >
          Mot de passe oublié ?
        </button>
      </div>
      <ToggleCGV :activate="CGV_value" @update:CGV="toggleCGV" /> 
      <button v-if="!loading" :style="buttonStyles" @click="submitForm">
        Connexion
      </button>
      <div
        v-else
        style="display: flex; justify-content: center; align-items: center"
      >
        <div class="loader-container">
          <div class="loader"></div>
        </div>
      </div>
      <p
        v-if="submitError"
        style="
          color: red;
          font-size: 0.6em;
          display: flex;
          justify-content: center;
          align-items: center;
        "
      >
        <!-- TODO : pull from i18n instead -->
        <i>
          {{ submitError }}
        </i>
      </p>
      <div
        class="signup"
        style="
          display: flex;
          flex-direction: column;
          text-align: center;
          margin: 0.5em auto;
        "
      >
        <p style="font-size: small; color: #000000c7">
          Vous n'avez pas encore de compte ? <br />
          <button
            style="text-decoration: underline; margin-top: 1em;background: none; border: none; color: #010fa8c7 ; cursor: pointer;"
            @click="redirectTo"
          >
            S'inscrire
          </button>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { customLogger } from "../../utils";
import PasswordTemplate from './PasswordForgetForm_Formacast.vue'
import OtpTemplate from './OtpForm_Formacast.vue'
import FormHeader from "../customs/FormHeader_Formacast.vue";
import ToggleCGV from "../customs/ToggleCGV_Formacast";
import specs from "@/specs";

export default {
  name: "LoginForm",
  components : {
    PasswordTemplate, 
    OtpTemplate,
    FormHeader,
    ToggleCGV
  },
  props: {
  
    /**
     * @param {string} redirect - name of the redirect to change to
     * @return {void}
     */
    redirect: {
      type: Function,
      required: false,
      default: () => {
        customLogger("Redirect Called");
      },
    },
  },
  data() {
    return {
      form_bg: specs.__LOGIN_BG,
      email: "",
      password: "",
      submitError: null,
      validationErrors: {
        email: false,
        password: false,
      },
      showPassword: false,
      emailPattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      passwordPattern: /^(?=.*\d).{6,}$/,
      errorStyles: {
        color: "red",
        border: "1px solid red",
        borderRadius: "1em",
        transition: "0.3s ease-in-out",
      },
      defaultStyles: {
        transition: "0.3s ease-in-out",
        color: "#747474",
        border: "1px solid #747474",
        borderRadius: "1em",
        backgroundColor: "transparent",
      },
      loading: false,
      currentPage : "",
      CGV_value: false,
    };
  },
  watch: {
    submitError() {
      setTimeout(()=>{
        this.submitError = null
      },2000)
    }
  },
  computed: {
    isFormValid() {
      return (
        this.emailPattern.test(this.email) &&
        this.passwordPattern.test(this.password) &&
        this.CGV_value 
      );
    },
    buttonStyles() {
      return {
        transition: "0.3s ease-in-out",
        backgroundColor: this.isFormValid ? "#264c78" : "#d3d3d3",
        padding: "10px 15px",
        color: this.isFormValid ? "white" : "#a9a9a9",
        borderRadius: "25px",
        margin: "0.5em auto",
        border: "none",
        cursor: this.isFormValid ? "pointer" : "default",
      };
    },
  },

  mounted() {
    const encodedUserData = localStorage.getItem("n-u");
    localStorage.removeItem("n-u");
    if (encodedUserData) {
      const decodedUserData = atob(encodedUserData);
      const userData = JSON.parse(decodedUserData);
      if (userData.email && userData.password) {
        this.email = userData.email;
        this.password = userData.password;
      }
    }
  },
  methods: {
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },

    /**
     * @param {string} fieldName - name of the field to validate
     * @param {RegExp} pattern - pattern to validate the field against
     */
    validateField(fieldName, pattern) {
      if (!pattern.test(this[fieldName])) {
        this.$set(this.validationErrors, fieldName, true);
        setTimeout(
          () => this.$set(this.validationErrors, fieldName, false),
          5000
        );
      } else {
        this.$set(this.validationErrors, fieldName, false);
      }
    },

    /***
     * @param {object} data - data to be sent to the server
     * @param {string} data.email - email of the user
     * @param {string} data.password - password of the user
     * @returns {Promise<void>} - returns a promise that resolves when the login is successful
     **/

  async submitForm() {
  if (!this.isFormValid) return;
  this.loading = true;
  try {
    await this.$store.dispatch("SIGNIN_USER_BY_EMAIL", {
      email: this.email,
      password: this.password,
    });
    
    // Vérifier l'état du profil de l'utilisateur
    const profileState = this.$store.state.user.data.profileState; 

    if (profileState === 'pending') {
      this.$store.dispatch("LOGOUT");
      this.triggerVerificationPage()
    } 
        
    else if (profileState === 'activated') {
      const At = new Date();
      await this.$store.commit("PUSH_MESSAGE", {
        sender_type: "bot",
        message: "chat.welcome",
        typing_indicator: false,
        sent_at: At.toISOString(),
      });
      await this.$store.dispatch("FETCH_USER_DATA", true);
      this.$store.commit("SHOW_AUTH_FLOW", false);

      if (this.$store.state.user.data?.subscription?.subscribe) {
          customLogger("User has a subscription");
          this.$store.commit("SHOW_SUBS_FLOW", false);
          await this.$store.dispatch("FETCH_USER_MESSAGES");
          this.$eb.emit("BoxMounted");
      } else {
          customLogger("User has no subscription");
          this.$store.commit("SHOW_SUBS_FLOW", true);
      }
    } else {
      // Gérer d'autres états du profil si nécessaire
      customLogger('Unknown profile state:', profileState);
      this.submitError = this.$store.state.user.lang == 'en' ? 'An unknown error occurred on your account please contact support' : 'Une erreur inconnue est survenue sur votre compte, veuillez contacter le support';
    }

  } catch (e) {
    this.submitError = e?.data?.error || e.message || 'An unknown error occurred';
    customLogger(e);
  }
  this.loading = false;
},


    triggerPasswordForgot(){
      if(this.currentPage =='verification' || this.currentPage == "password")  return this.currentPage = ""
      return this.currentPage = "password"
    },
    triggerVerificationPage(){
      if(this.currentPage =='verification' || this.currentPage == "password")  return this.currentPage = ""
      return this.currentPage = "verification"
    },
    toggleCGV() {
      this.CGV_value = !this.CGV_value;
    },
    
    redirectTo() {
      this.redirect("signup");
    },
  },
};
</script>
